<template>
    <div class="row">
        <div v-if="isBusinessAccount" class="small-12 columns" :class="{ error: showMainAccountHolderCompanyNameErrorText }">
            <label>
                Firmenname
                <input type="text" v-model="formData.main_account_holder_company_name"/>
            </label>
            <small class="error" v-if="showMainAccountHolderCompanyNameErrorText">
                {{ mainAccountHolderCompanyNameErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMainAccountHolderLawformErrorText }">
            <label>
                {{ accountHolderLawformText }}
                <select v-model="formData.main_account_holder_lawform">
                    <option
                        v-for="lawform in lawformSelectData"
                        :key="lawform.value"
                        :value="lawform.value"
                    >
                        {{lawform.text}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showMainAccountHolderLawformErrorText">
                {{ mainAccountHolderLawformErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMainAccountHolderPrenameErrorText }">
            <label>
                {{ accountHolderPrenameText }}
                <input type="text" v-model="formData.main_account_holder_prename"/>
            </label>
            <small class="error" v-if="showMainAccountHolderPrenameErrorText">
                {{ mainAccountHolderPrenameErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMainAccountHolderSurnameErrorText }">
            <label>
                {{ accountHolderSurnameText }}
                <input type="text" v-model="formData.main_account_holder_surname"/>
            </label>
            <small class="error" v-if="showMainAccountHolderSurnameErrorText">
                {{ mainAccountHolderSurnameErrorText }}
            </small>
        </div>
        <div v-if="isPrivateAccount" class="small-12 columns">
            <div class="panel radius">
                <p>
                    Weitere Kontoinhaber können ggf. im Abschnitt "Weitere Daten" angegeben werden.
                    Hier kann im Falle eines minderjährigen Kontoinhabers auch ein Elternteil als gesetzlicher Vertreter erfasst werden.
                </p>
            </div>
        </div>
        <div class="small-12 columns" :class="{ error: showMainAccountHolderMailErrorText }">
            <label>
                E-Mail Adresse (für die Antwort der Bank)
                <input type="text" v-model="formData.main_account_holder_mail"/>
            </label>
            <small class="error" v-if="showMainAccountHolderMailErrorText">
                {{ mainAccountHolderMailErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMainAccountHolderPaymentAccountNumberErrorText }">
            <label>
                IBAN eines alternativen Zahlungskontos (für Rückerstattungen der Bank)
                <input type="text" v-model="formData.main_account_holder_payment_account_number"/>
            </label>
            <small class="error" v-if="showMainAccountHolderPaymentAccountNumberErrorText">
                {{ mainAccountHolderPaymentAccountNumberErrorText }}
            </small>
        </div>
    </div>
</template>

<script>
import AccountTypes from '../../constants/AccountTypes';
import TypeHelper from '../../helper/TypeHelper';
import Validation from '../../helper/Validation';
import Lawforms from '../../constants/Lawforms';

export default {
    name: 'AccountHolderDataFormStep',
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    account_type:                                   null,
                    account_number:                                 null,
                    bank_name:                                      null,
                    bank_mail:                                      null,
                    main_account_holder_lawform:                    null,
                    main_account_holder_prename:                    null,
                    main_account_holder_surname:                    null,
                    main_account_holder_mail:                       null,
                    main_account_holder_company_name:               null,
                    is_main_account_holder_minor:                   null,
                    main_account_holder_payment_account_number:     null,
                    has_sub_account_holder:                         null,
                    sub_account_holder_lawform:                     null,
                    sub_account_holder_surname:                     null,
                    sub_account_holder_prename:                     null,
                    is_allowed_representor:                         null,
                    phishing_damage_amount:                         null,
                    phishing_date:                                  null
                }
            }
        }
    },
    data: () => ({
        formData: {
            main_account_holder_lawform:                    null,
            main_account_holder_prename:                    null,
            main_account_holder_surname:                    null,
            main_account_holder_mail:                       null,
            main_account_holder_company_name:               null,
            main_account_holder_payment_account_number:     null,
        },
        validation: {
            isFormDirty: false,
            isMainAccountHolderLawformDirty: false,
            isMainAccountHolderPrenameDirty: false,
            isMainAccountHolderSurnameDirty: false,
            isMainAccountHolderMailDirty: false,
            isMainAccountHolderCompanyNameDirty: false,
            isMainAccountHolderPaymentAccountNumberDirty: false,
        },
        lawformSelectData: [
            Lawforms.HERR,
            Lawforms.FRAU
        ],
    }),
    computed: {
        isBusinessAccount()
        {
            return this.caseData.account_type === AccountTypes.ACCOUNT_TYPE_BUSINESS.value;
        },
        isPrivateAccount()
        {
            return this.caseData.account_type === AccountTypes.ACCOUNT_TYPE_PRIVATE.value;
        },
        accountHolderLawformText()
        {
            if (this.isBusinessAccount)
                return 'Anrede des Bevollmächtigten';
            else
                return 'Anrede des Kontoinhabers';
        },
        accountHolderPrenameText()
        {
            if (this.isBusinessAccount)
                return 'Vorname des Bevollmächtigten';
            else
                return 'Vorname des Kontoinhabers';
        },
        accountHolderSurnameText()
        {
            if (this.isBusinessAccount)
                return 'Nachname des Bevollmächtigten';
            else
                return 'Nachname des Kontoinhabers';
        },
        showMainAccountHolderLawformErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMainAccountHolderLawformDirty)
                && TypeHelper.isNotNullOrUndefined(this.mainAccountHolderLawformErrorText);
        },
        showMainAccountHolderPrenameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMainAccountHolderPrenameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mainAccountHolderPrenameErrorText);
        },
        showMainAccountHolderSurnameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMainAccountHolderSurnameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mainAccountHolderSurnameErrorText);
        },
        showMainAccountHolderMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMainAccountHolderMailDirty)
                && TypeHelper.isNotNullOrUndefined(this.mainAccountHolderMailErrorText);
        },
        showMainAccountHolderCompanyNameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMainAccountHolderCompanyNameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mainAccountHolderCompanyNameErrorText);
        },
        showMainAccountHolderPaymentAccountNumberErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMainAccountHolderPaymentAccountNumberDirty)
                && TypeHelper.isNotNullOrUndefined(this.mainAccountHolderPaymentAccountNumberErrorText);
        },
        mainAccountHolderLawformErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.main_account_holder_lawform, validators);
        },
        mainAccountHolderPrenameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.main_account_holder_prename, validators);
        },
        mainAccountHolderSurnameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.main_account_holder_surname, validators);
        },
        mainAccountHolderMailErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isEmail
            ];

            return Validation.runValidation(this.formData.main_account_holder_mail, validators);
        },
        mainAccountHolderCompanyNameErrorText()
        {
            let validators = [];

            if (this.caseData.account_type === AccountTypes.ACCOUNT_TYPE_BUSINESS.value)
                validators.push(Validation.isNotNull);

            return Validation.runValidation(this.formData.main_account_holder_company_name, validators);
        },
        mainAccountHolderPaymentAccountNumberErrorText()
        {
            let validators = [];

            if (TypeHelper.isNotNullOrUndefined(this.formData.main_account_holder_payment_account_number)
                && this.formData.main_account_holder_payment_account_number !== '')
                validators.push(Validation.isIban);

            return Validation.runValidation(this.formData.main_account_holder_payment_account_number, validators);
        },
    },
    methods: {
        validate()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        isFormValid()
        {
            let isValid = true;
            isValid = isValid && (this.mainAccountHolderLawformErrorText === null);
            isValid = isValid && (this.mainAccountHolderPrenameErrorText === null);
            isValid = isValid && (this.mainAccountHolderSurnameErrorText === null);
            isValid = isValid && (this.mainAccountHolderMailErrorText === null);
            isValid = isValid && (this.mainAccountHolderCompanyNameErrorText === null);
            isValid = isValid && (this.mainAccountHolderPaymentAccountNumberErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeCaseData', this.formData);
        }
    },
    watch: {
        'caseData.account_type': function(newValue)
        {
            if (newValue === AccountTypes.ACCOUNT_TYPE_PRIVATE.value)
                this.formData.main_account_holder_company_name = null;

            this.emitValidity();
        },
        'formData.main_account_holder_lawform': function()
        {
            this.validation.isMainAccountHolderLawformDirty = true;
        },
        'formData.main_account_holder_prename': function()
        {
            this.validation.isMainAccountHolderPrenameDirty = true;
        },
        'formData.main_account_holder_surname': function()
        {
            this.validation.isMainAccountHolderSurnameDirty = true;
        },
        'formData.main_account_holder_mail': function()
        {
            this.validation.isMainAccountHolderMailDirty = true;
        },
        'formData.main_account_holder_company_name': function()
        {
            this.validation.isMainAccountHolderCompanyNameDirty = true;
        },
        'formData.main_account_holder_payment_account_number': function()
        {
            this.validation.isMainAccountHolderPaymentAccountNumberDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        },
    }
};
</script>

<style scoped>
.error label {
    color: #4d4d4d;
}
</style>